export const HOME_PAGE = '/';
export const KNOWLEDGEBASE_PAGE = '/knowledgebase';
export const ABOUT_PAGE = '/about';
export const BLOG_PAGE = '/blog';
export const COMPANY_PAGE = '/company';
export const MANAGEMENT_PAGE = '/management';
export const WORK_WITH_US_PAGE = '/work-with-us';
export const CONTACT_PAGE = '/contact-us';
export const HELP_PAGE = '/help';
export const FAQS_PAGE = '/faqs';
export const PRIVACY_POLICY_PAGE = '/privacy-policy';
export const TERMS_CONDITIONS_PAGE = '/terms-conditions';
export const OUR_FOCUS_PAGE = '/our-focus';
export const FOCUS_1_PAGE = '/focus-1';
export const FOCUS_2_PAGE = '/focus-2';
export const FOCUS_3_PAGE = '/focus-3';
export const GAS_STATION_PAGE = '/gas-stations';
export const CONVENIENCE_RETAIL_PAGE = '/convenience-retail';
export const HOSPITALITY_PAGE = '/hospitality';
export const STORE_RETAIL_PAGE = '/store-retail';
export const FEATURES_PAGE = '/features';
export const FEATURE_1_PAGE = '/feature-1';
export const FEATURE_2_PAGE = '/feature-2';
export const FEATURE_3_PAGE = '/feature-3';
export const FEATURE_4_PAGE = '/feature-4';
export const LEADERSHIP_PAGE = '/leadership';
export const CIRRUS_FACEBOOK_SOC = '#cirrus_facebook';
export const CIRRUS_TWITTER_SOC = '#cirrus_twitter';
export const CIRRUS_INSTAGRAM_SOC = '#cirrus_instagram';
export const CIRRUS_LINKEDIN_SOC = '#cirrus_linkedin';
